import { render, staticRenderFns } from "./LeadsCrumb.vue?vue&type=template&id=11675bd0&"
import script from "./LeadsCrumb.vue?vue&type=script&lang=ts&"
export * from "./LeadsCrumb.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports